/*
 * Public API Surface of ngx-lib/core/portal
 */
export * from './attach.directive';
export * from './target.directive';
export * from './portal.service';
